function About() {
  const principles = [
    { icon: "ri-emotion-laugh-line", title: "快乐第一", desc: "每一话都先把好笑放在第一位，让你笑出声是我们的最大追求。" },
    { icon: "ri-community-line", title: "贴近日常", desc: "取材自真实生活小烦恼，让每个读者都能在大黄丫头身上看到自己。" },
    { icon: "ri-leaf-line", title: "轻松解压", desc: "拒绝沉重，主打轻松向内容，让你在碎片时间里快速放松下来。" },
    { icon: "ri-group-line", title: "陪伴成长", desc: "从上线至今持续更新，陪伴每一位读者度过无数个想笑的瞬间。" },
  ];

  return (
    <section id="about" className="bg-background-100 py-16 md:py-20">
      <div className="container-page">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=cheerful%20cartoon%20girl%20character%20winking%20and%20giving%20a%20thumbs%20up%2C%20vibrant%20warm%20orange%20and%20cream%20manga%20illustration%20style%2C%20playful%20expressive%20face%2C%20soft%20warm%20studio%20background%20with%20sunburst%20effect%2C%20bold%20clean%20comic%20lines&width=1000&height=760&seq=about-manga-char&orientation=portrait"
              alt="大黄丫头漫画主角角色插画"
              className="aspect-[4/3] w-full rounded-3xl object-cover"
            />
            <div className="absolute -bottom-5 -right-4 hidden rounded-2xl bg-primary-500 px-5 py-4 text-background-50 shadow-sm md:block">
              <div className="font-heading text-2xl">210+ 话</div>
              <div className="text-xs">快乐持续放送</div>
            </div>
          </div>

          <div>
            <span className="eyebrow">
              <i className="ri-lightbulb-flash-line"></i>
              关于大黄丫头
            </span>
            <h2 className="section-title mt-3">把每一个平凡日子，都过成笑点合集</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              大黄丫头漫画的灵感，来自那些被生活折腾、却又忍不住笑出声的普通人。主角「丫头」有点迷糊、有点拖延、有点贪吃，却总能在鸡飞狗跳里找到快乐。我们用轻松幽默的笔触，记录她搞笑日常里的每一个瞬间，希望这些幽默片段能成为你忙碌生活里的一剂「快乐解压药」。
            </p>

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {principles.map((p) => (
                <div key={p.title} className="flex gap-3 rounded-2xl bg-background-50 p-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-xl text-primary-600">
                    <i className={p.icon}></i>
                  </span>
                  <div>
                    <div className="font-heading text-base text-foreground-950">{p.title}</div>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;